import type { AttendanceRecord, OrderRecord, StaffRecord } from './api'

export type View = 'dashboard' | 'orders' | 'staff' | 'attendance' | 'performance' | 'stores' | 'rules' | 'accounts' | 'audit'

export const money = (amount: number, currency = 'MYR') =>
  `${currency === 'MYR' ? 'RM' : currency} ${Number(amount || 0).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

export const formatDateTime = (value: string | null | undefined) => value
  ? new Intl.DateTimeFormat('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(value))
  : '-'

export const formatTime = (value: string | null | undefined) => value
  ? new Intl.DateTimeFormat('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(value))
  : '-'

export const formatDuration = (minutes: number | null | undefined) => {
  const value = Math.max(0, minutes ?? 0)
  return `${String(Math.floor(value / 60)).padStart(2, '0')}:${String(value % 60).padStart(2, '0')}`
}

export const orderStatus: Record<OrderRecord['status'], { label: string; tone: string }> = {
  WAITING: { label: '待开始', tone: 'neutral' },
  IN_SERVICE: { label: '服务中', tone: 'success' },
  AWAITING_SETTLEMENT: { label: '待结算', tone: 'warning' },
  COMPLETED: { label: '已完成', tone: 'success' },
  CLOSED: { label: '已关闭', tone: 'closed' },
}

export const paymentMethod: Record<OrderRecord['paymentMethod'], string> = {
  CASH: '现金', CARD: '刷卡', ONLINE: '在线支付', OTHER: '其他',
}

export const staffStatus: Record<StaffRecord['serviceStatus'], { label: string; tone: string }> = {
  IDLE: { label: '空闲中', tone: 'success' },
  IN_SERVICE: { label: '服务中', tone: 'warning' },
  OFF_DUTY: { label: '未当班', tone: 'closed' },
}

export const attendanceStatus: Record<AttendanceRecord['status'], { label: string; tone: string }> = {
  NORMAL: { label: '正常', tone: 'success' },
  LATE: { label: '迟到', tone: 'warning' },
  EARLY_LEAVE: { label: '早退', tone: 'warning' },
  ABSENT: { label: '缺勤', tone: 'closed' },
  LEAVE: { label: '请假', tone: 'neutral' },
  CORRECTED: { label: '已修正', tone: 'neutral' },
}

export const errorMessage = (reason: unknown, fallback: string) => reason instanceof Error ? reason.message : fallback

export const dayRange = (date: string) => {
  const fromDate = new Date(`${date}T00:00:00`)
  const toDate = new Date(fromDate.getTime() + 24 * 60 * 60 * 1000)
  return { from: fromDate.toISOString(), to: toDate.toISOString() }
}

export const monthRange = (period: string) => {
  const [year, month] = period.split('-').map(Number)
  const businessOffsetMs = 8 * 60 * 60 * 1000
  const fromDate = new Date(Date.UTC(year, month - 1, 1) - businessOffsetMs)
  const toDate = new Date(Date.UTC(year, month, 1) - businessOffsetMs)
  return { from: fromDate.toISOString(), to: toDate.toISOString() }
}

export const newIdempotencyKey = () => globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`
